import { CustomError } from './custom-error';
import { CodeError } from '../constant/text.constant';

export class EmailOrPhoneValidationError extends CustomError {
  private static readonly CODE = CodeError.INVALID_EMAIL_OR_PHONE;

  constructor() {
    super(EmailOrPhoneValidationError.CODE);
  }
}
